import { isEmpty, parseToJSON } from './object'

const SUCCESS_HTTP_RESPONSE_CODE = [200, 201, 204]

const createAPIErrorObject = (
  status,
  statusText,
  responseBody,
  errorMessage = '',
) => {
  const error = new Error(errorMessage)
  error.name = 'API_REQUEST_ERROR'
  error.statusCode = status
  error.statusText = statusText
  error.responseBody = responseBody
  return error
}

// eslint-disable-next-line consistent-return
export const makeAPIRequest = ({
  url,
  method = 'POST',
  json = true,
  data,
} = {}) =>
  // eslint-disable-next-line consistent-return
  new Promise((resolve, reject) => {
    try {
      if (isEmpty(url)) {
        throw createAPIErrorObject(
          '"url" and "method" are mandatory to make an API request',
        )
      }

      const { XMLHttpRequest } = window
      const request = new XMLHttpRequest()

      request.onreadystatechange = () => {
        const { readyState, status, statusText } = request
        if (readyState === 4) {
          const { responseText } = request
          let body
          try {
            body = parseToJSON(responseText)
          } catch (error) {
            body = responseText
          }
          if (SUCCESS_HTTP_RESPONSE_CODE.includes(status)) {
            // eslint-disable-next-line no-console
            console.debug(
              'apiRequestHelper',
              'makeAPIRequest',
              'responseText',
              responseText,
            )
            return resolve(body)
          }
          return reject(
            createAPIErrorObject(
              status,
              statusText,
              body,
              `status: ${status} :: statusText: ${statusText}`,
            ),
          )
        }
        return null
      }
      request.open(method, url)
      request.setRequestHeader('x-csrf-token', window.reqToken)

      // if (!json && data && data.append) {
      //   data.append('_csrf', window.reqToken);
      // }

      if (json && data && typeof data === 'object') {
        // data._csrf = window.reqToken;
        data = JSON.stringify(data)
        request.setRequestHeader('Content-Type', 'application/json')
      }

      request.send(data)
    } catch (err) {
      // @TODO - Handle Rejection
      // eslint-disable-next-line no-console
      console.error(
        'apiRequestHelper',
        'makeAPIRequest',
        'Error making API Request',
        err,
      )
      return reject(err)
    }
  })
